const Badge = ({ className, children, showSmallText = true, ...rest }) => {
  return (
    <div
      className={`badge ${showSmallText ? 'font-small-3' : ''} ${className}`}
      {...rest}
    >
      {children}
    </div>
  )
}

export default Badge
